<template>
  <div :id="targetLevel">
    <membership-card :level="level" :next-level="nextLevel" :id="targetLevel"></membership-card>
    <b-popover :target="targetLevel" triggers="hover" placement="bottom">
      <levels-list :all-levels="allLevels" ></levels-list>
    </b-popover>
  </div>
</template>

<script>
import MembershipCard from "./MembershipCard";
import LevelsList from "./LevelsList";
export default {
  name: "Membership",
  props: ['level', 'nextLevel', 'allLevels'],
  components: {LevelsList, MembershipCard},
  computed: {
    targetLevel() {
      return 'target-level-' + this.level?.id
    },
  }
}
</script>

<style scoped>

</style>
